import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "text", "spinner"];

  async translate({ params }) {
    // Show spinner and disable button
    this.buttonTarget.disabled = true;
    this.textTarget.classList.add("d-none");
    this.spinnerTarget.classList.remove("d-none");

    try {
      const url = new URL("/translate", document.location);
      url.searchParams.append(
        "text",
        document.getElementById(params.source).value,
      );

      const response = await fetch(url.href);
      if (response.ok) {
        const target = document.getElementById(params.target);
        response.text().then((text) => {
          target.value = text;
          target.dispatchEvent(new Event("input")); //trigger autogrow
        });
      }
    } finally {
      // Hide spinner and re-enable button
      this.buttonTarget.disabled = false;
      this.textTarget.classList.remove("d-none");
      this.spinnerTarget.classList.add("d-none");
    }
  }
}
